import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import IAction from './IAction'

class SpecificDelete extends IAction {
    fn = () => {
        return this.props.onDelete
    }
    icon = () => {
        return 'delete'
    }
    label = () => {
        return i18n.delete
    }
    id = () => {
        return 'specificdelete_action_navbar'
    }
}

SpecificDelete.propTypes = {
    onDelete: PropTypes.func.isRequired,
}

export default SpecificDelete
